<template>
  <div>
    <form @submit.prevent="handleFormSubmit" class="form" v-if="form">
      <register-title class="form__title">Высший орган</register-title>
      <register-input
        v-model="form.full_name"
        componentID="series"
        inputType="text"
        label="Ф.И.О. либо полное наименование юридического лица "
        inputPlaceholder="Ф.И.О. либо полное наименование юридического лица "
        :isRequired="true"
        class="form__input"
      />
      <div class="select-container">
        <label class="label">Гражданство</label>
        <exp-select
          :options="registrationCountryList()"
          v-model="form.citizenship"
          title="Выберите страну"
        ></exp-select>
      </div>
      <register-input
        componentID="user-iin"
        label="ИИН/БИН"
        inputPlaceholder="ИИН/БИН"
        :isRequired="true"
        class="form__input"
        :inputMaxLength="12"
        v-model="form.iin"
      />
      <p
        class="login-form__error"
        v-if="form.iin.length == 12 && !validateIin(form.iin)"
      >
        Неверный ИИН
      </p>
      <register-input
        v-model="form.power_document_name"
        componentID="operation_register_number"
        inputType="text"
        inputPlaceholder="Наименование документа на основании которых установлен состав высшего органа "
        label="Наименование документа на основании которых установлен состав высшего органа "
        :isRequired="false"
        class="form__input"
      />
      <register-input
        v-model="form.power_document_approved_at"
        inputType="date"
        componentID="validity-date"
        label="Дата последней редакции"
        :isRequired="false"
        class="form__input"
      />

      <hr class="horizontal-line" />
      <question-input
        componentID="is-individual"
        :defaultValue="form.is_legal ? 'yes' : 'no'"
        question="Является ли Юридическим лицом ?"
        class="form__input"
        @handleSelect="value => (form.is_legal = value === 'yes' ? 1 : 0)"
      ></question-input>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <button class="button form__button" @click="nextStep()">
            Назад
          </button>
        </div>
        <div class="col-xs-12 col-sm-6">
          <button class="button filled form__button">Сохранить</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import regFormMixin from "../form_mixin";
import QuestionInput from "../../register/QuestionInput";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["body_member_data"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      // form: null,
      form: {
        is_legal: 0,
        full_name: "",
        citizenship: null,
        iin: "",
        power_document_name: "",
        power_document_approved_at: ""
      },
      form_dates: ["power_document_approved_at"]
    };
  },
  components: {
    QuestionInput
  },
  mixins: [regFormMixin],
  methods: {
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        if (this.$route.params.member_id) {
          FhsAxios.get(
            `profile/user-control-member/${this.$route.params.member_id}`
          ).then(res => {
            if (res.data.status) {
              this.form = res.data.result;
              this.form_dates.forEach(date => {
                this.form[date] = this.dateFormat(this.form[date]);
              });
              // this.from = res.data.result;
            }
          });
          // console.log(this.isKazDoc(this.form.document_type));
          this.old_form = JSON.parse(JSON.stringify(this.form));
        }
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "legal-control-form-detail" });
    },
    saveData() {
      let url = `profile/user-control-member${
        this.$route.params.member_id ? "/" + this.$route.params.member_id : ""
      }`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      form.user_control_id = this.$route.params.control_id;
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.$toasted.success("Данные сохранены");
          this.nextStep();
          return;
        }
        this.$toasted.error("Произошла ошибка");
        this.$emit("loading-status", false);
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
